<panel width="400">
	<form>
		<h1>{{ 'invoice.edit-invoice-duedate.header' | translate }}</h1>
		<section>
			<date-input [required]="true" [label]="'edit-invoice-duedate.due-date' | translate" [(value)]="dueDate" />
		</section>
		<section>
			<button confirm (click)="editDueDate()" [label]="'general.save' | translate"></button>
		</section>
	</form>
</panel>
